import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { CropVarietiesByCropId, CropVarietiesByCropIdState } from 'src/app/shared/models';

import { CropVarietyActions, CropVarietyActionTypes } from '../actions/crop-variety.actions';

export const adapter: EntityAdapter<CropVarietiesByCropId> =
  createEntityAdapter<CropVarietiesByCropId>();
export const initialState: CropVarietiesByCropIdState = adapter.getInitialState({});

export const cropVarietyReducer = (
  state = initialState,
  action: CropVarietyActions,
): CropVarietiesByCropIdState => {
  switch (action.type) {
    case CropVarietyActionTypes.LoadCropVarietiesByCropIdSuccess: {
      return adapter.setOne({ id: action.cropId, cropVarieties: action.cropVarieties }, state);
    }

    case CropVarietyActionTypes.LoadCropVarietiesByCropIdsSuccess: {
      action.cropIds.forEach(
        (cropId) =>
          (state = adapter.setOne(
            { id: cropId, cropVarieties: action.cropVarieties.filter((v) => v.cropId === cropId) },
            state,
          )),
      );
      return state;
    }

    default: {
      return state;
    }
  }
};
